/**
 * Templating for translation strings
 *
 * Put variables into the translation like this `Select {label}`
 * And then template(text.my_translation, { label })
 */
export function template(
  text: string,
  variables: Record<string, string | number>
) {
  let result = text;
  for (const [key, value] of Object.entries(variables)) {
    result = result.replace(`{${key}}`, String(value));
  }
  return result;
}
